import { combineReducers } from 'redux';
import accountingReducer from './accounting.reducer';
import agentReducer from './agent.reducer';
import alertReducer from './alert.reducer';
import authReducer from './auth.reducer';
import bankingReducer from './banking.reducer';
import budgetReducer from './budget.reducer';
import cardReducer from './card.reducer';
import companyReducer from './company.reducer';
import expenseReducer from './expense.reducer';
import invoiceReducer from './invoice.reducer';
import listPageCacheReducer from './listPageCache.reducer';
import mainReducer from './main.reducer';
import openBankingReducer from './openBanking.reducer';
import overviewReducer from './overview.reducer';
import subscriptionReducer from './subscription.reducer';
import teamsReducer from './teams.reducer';
import transactionReducer from './transaction.reducer';
import userReducer from './user.reducer';
import vendorReducer from './vendor.reducer';

const rootReducer = combineReducers({
  accounting: accountingReducer,
  agent: agentReducer,
  alert: alertReducer,
  auth: authReducer,
  banking: bankingReducer,
  budget: budgetReducer,
  card: cardReducer,
  company: companyReducer,
  expense: expenseReducer,
  invoice: invoiceReducer,
  listPageCache: listPageCacheReducer,
  main: mainReducer,
  openBanking: openBankingReducer,
  overview: overviewReducer,
  subscription: subscriptionReducer,
  teams: teamsReducer,
  transaction: transactionReducer,
  user: userReducer,
  vendor: vendorReducer
});

export default rootReducer;
